// #region Imports
import React, { useState, useEffect } from 'react';
import useCaixa from '../../hooks/useCaixa';
import CaixaTable from '../../components/Caixa/CaixaTable/CaixaTable';
import CaixaCrud from '../../components/Caixa/CaixaCrud/CaixaCrud';
import MovimentosModal from '../../components/Caixa/MovimentosModal/MovimentosModal';
// #endregion

export default function CaixaPage() {
  // #region Hook domínio
  const {
    listar,
    abrirCaixa,
    fechar,
    stats,
    loading,
    carregarMovimentos,
    movimentos,
    obter,
  } = useCaixa();
  const [crudOpen, setCrudOpen] = useState(false);
  const [movOpen, setMovOpen] = useState(false);
  const [movCaixaId, setMovCaixaId] = useState(null);
  // #endregion

  // #region Estado local (filtros/paginação)
  const [filters, setFilters] = useState({ q: '', status: 'TODOS', periodo: 'TODOS' });
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [listState, setListState] = useState({ data: [], total: 0 });
  // #endregion

  // #region Efeito listar
  useEffect(() => {
    const res = listar({ ...filters, page, pageSize });
    setListState(res);
  }, [listar, filters, page, pageSize]);
  // #endregion

  // #region Handlers
  function handleFiltersChange(next) {
    setFilters(next);
    setPage(1);
  }

  function handleCreate() {
    setCrudOpen(true);
  }

  function handleClose(id) {
    if (window.confirm('Fechar caixa?')) fechar(id, { manual: true });
  }

  function handleCrudCreate(payload) {
    abrirCaixa(payload);
  }

  async function handleOpenMov(id) {
    setMovCaixaId(id);
    await carregarMovimentos(id);
    setMovOpen(true);
  }
  // #endregion

  // #region Render
  return (
    <div className="caixa-page">
      <CaixaTable
        loading={loading}
        stats={stats}
        filters={filters}
        data={listState.data}
        total={listState.total}
        page={page}
        pageSize={pageSize}
        onFiltersChange={handleFiltersChange}
        onPageChange={p => setPage(p)}
        onCreate={handleCreate}
        onClose={handleClose}
        onOpenMovimentos={handleOpenMov}
      />
      <CaixaCrud
        open={crudOpen}
        onClose={() => setCrudOpen(false)}
        onCreate={handleCrudCreate}
      />
      <MovimentosModal
        open={movOpen}
        onClose={() => setMovOpen(false)}
        caixa={movCaixaId ? obter(movCaixaId) : null}
        movimentos={movimentos}
      />
    </div>
  );
  // #endregion
}
